import React from 'react';
import Page from "./Page";

const NotFoundPage = () => {
  return (
    <Page>
      <div className="grid" style={{marginLeft: '30px'}}>
        <h1>Page not found!</h1>
      </div>
    </Page>
  )
}

export default NotFoundPage;